import Prism from 'prismjs'

// Ensure Prism is available globally for its components
// Use globalThis for broad compatibility across environments
const root = (typeof globalThis !== 'undefined'
  ? globalThis
  : typeof global !== 'undefined'
    ? global
    : {}) as any

root.Prism = root.Prism || Prism

export default Prism

